export default {
    feed: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        maxWidth: '1200px',
        margin: '20px 0 5vh 0',
        '@media (max-width: 767px)': {
            padding: '0',
        }
    },
    data: {
        topText: `At Wiki.Credit our goal is to help consumers better understand the confusing 
        world of credit and how it can impact their lives. Credit, and good credit health, 
        have become a requirement in our society. Your ability to buy a home, a car, a cell phone, 
        obtain insurance and even get a job are now reliant, in many ways, on your credit health. 
        Wiki.Credit provides a wealth of knowledge at your fingertips written in a way that the 
        credit laymen can understand. Find the right loan, find the right credit card and find the 
        right knowledge. Start increasing your credit IQ today!`
    },
    overrideFeatured: {
        featuredTitle: {
            marginRight: '25px',
            fontSize: '3rem',
            fontFamily: 'Roboto'
        },
        itemTitle: {
            fontFamily: 'Roboto'
        }
    },
    overrideKnowledge: {
        contentTitleSpan: { fontFamily: 'Roboto', color: '#278cb1', },
        typeColumnTitle: { fontFamily: 'Roboto', color: '#092c7e' },
        // columnItemTitle: { color: '#092c7e' }
    },
    overrideEditorial: {
        contentTitleSpan: { fontFamily: 'Roboto', color: '#278cb1' },
        editorialTitle: { fontFamily: 'Roboto', color: '#092c7e' },
        articleTitle: { fontFamily: 'Roboto' }
    },
    overrideLatest: {
        contentTitleSpan: { fontFamily: 'Roboto', color: '#278cb1' },
        articleTitle: { fontFamily: 'Roboto' }
    },
    overridePopular: {
        contentTitleSpan: { fontFamily: 'Roboto', color: '#278cb1' },
        cardTitle: { fontFamily: 'Roboto' }
    },
}